import React, { Component } from 'react';
import {withRouter} from 'react-router-dom';
import withStyles from 'react-jss'
import {withContext} from '../../../custom/StateProvider';
import Utils from '../../../../util';
import {API, BROKERID} from "../../../../config";
import CancelOrderButton from './cancelOrderButton';

const moment = require('moment');

const allOrders = API.service('all-orders');

const styles = theme => ({
    tableRow:{
        borderWidth:'1px 0 1px 0',
        borderColor:'#e6e6e6',
        '&:nth-of-type(2n)':{
            backgroundColor:'#f6f6f6'
        },
        '& td':{
            padding:7,
        },
        '&:first-of-type':{
            borderTop:0,
        },
    },
    tableHead:{
        borderWidth:'1px 0 1px 0',
        borderColor:'#e6e6e6',
        backgroundColor:'#6e6e6e',
        color:'white'
    },
    accountDetails:{
        width:'300px',
        position:'absolute',
        display:'none',
        border:'2px solid #6e6e6e',
        backgroundColor:'white',
        top:0,
        right:50,
        zIndex:1000,
    },
    bankDetails:{
        '&:hover .details_drawer':{
            display:'block'
        }
    },
    cancelButton: {
        background: 'red',
        color: 'white !important',
        height: 14,
        fontSize: 10,
        minHeight: 14,
        padding: '0px 11px',
        borderRadius: '4px',
        whiteSpace: 'nowrap',
    },
});

class InvestorWithdrawals extends Component {
    state={
        orders:[]
    };

    getHoldings = () => {
        const app = this;
        allOrders.find({query:{
            _investor_account:this.props.investor._account,
            _status: this.props._state,
            _broker_id: BROKERID,
            $limit:200,
            //_type: {$ne: ['B','M']},
            incl: ['company', 'complete'],
        }}).then(s=>{
            app.setState({
                orders:s.data
            })

            app.props.context.update({
                updateOrders:false
            })
        })
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.investor._id !== this.props.investor._id) {
            this.getHoldings();
        }

        if (prevProps.context.updateOrders === false && this.props.context.updateOrders === true) {
            this.getHoldings();
        }
    }

    timer = null;

    componentDidMount() {
        const app = this;
        app.getHoldings()

        this.timer = window.setInterval(()=> {
              app.getHoldings();
        },5000);
    }

    componentWillUnmount() {
        clearInterval(this.timer);
    }

    render() {
        const {classes} = this.props;

        return (
            <React.Fragment>
                <table className={'w-full'}>
                    <tr className={classes.tableHead}>
                        <td>Date</td>
                        <td className={'text-center pl-2'}>Instrument</td>
                        <td className={'text-center pl-2'}>Type</td>
                        <td className={'text-center pl-2'}>Price</td>
                        <td className={'text-center pl-2'}>Value</td>
                        <td className={'text-center pl-2'}></td>
                        <td className={'text-center pl-2'}>Quantity</td>
                        <td className={'text-center pl-2'} style={{width:'160px'}}>Action</td>
                    </tr>
                    {this.state.orders.map((v,i)=>{
                        let { currency_symbol } = (v.Companies.length !== 0) ? Utils.getCurrency(v.Companies[0]._currency) : '';
                        return (
                            <tr className={classes.tableRow}>
                                <td>{v.createdAt ? moment(v.createdAt).format('ll') : '-'}</td>
                                <td>{v.Companies[0]._company_symbol}</td>
                                <td>{(typeof v._target_seller_account === 'undefined') ? 'SELL' : 'BUY'}</td>

                                {(v.Companies[0]._share_type === 'D') &&
                                    <td>{(v.Completed_Trades.length > 0) ? v.Completed_Trades[0]._price*100: v._price * 100}%</td>
                                }
                                {(v.Companies[0]._share_type !== 'D') &&
                                    <td>{currency_symbol}{(v.Completed_Trades.length > 0) ? Utils.addThousandCommas(v.Completed_Trades[0]._price) : Utils.addThousandCommas(v._price)}</td>
                                }

                                <td>{currency_symbol}{(v.Completed_Trades.length > 0) ? Utils.addThousandCommas(v.Completed_Trades[0]._price * v.Completed_Trades[0]._quantity) : Utils.addThousandCommas(v._price * v._quantity)}</td>
                                <td>{v._type}</td>
                                <td>{(v.Completed_Trades.length > 0) ? Utils.addThousandCommas(v.Completed_Trades[0]._quantity, '0,0') : Utils.addThousandCommas(v._quantity, '0,0')}</td>
                                <td>
                                    {(v._status === 0) &&
                                        <CancelOrderButton order={v}/>
                                    }
                                    {(v._status === 3) &&
                                    <span style={{ fontSize: 10 }}>Cancelled { v.updatedAt ? moment(v.updatedAt).format('ll') : '-'}</span>
                                    }
                                    {(v._status === 1) &&
                                    <span style={{ fontSize: 10 }}>{ v.updatedAt ? moment(v.updatedAt).format('ll') : '-'}</span>
                                    }
                                </td>
                            </tr>
                        )
                    })}
                </table>
            </React.Fragment>
        )
    }
}

export default withContext(withStyles(styles,{withTheme:true})(withRouter(InvestorWithdrawals)));
